import { blue } from '@material-ui/core/colors';

export default () => ({
  textHighlight: {
    color: blue[600],
    cursor: 'pointer',
  },
  container: { margin: '4rem 0 2rem 0' },
});
